import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {CategoryParser} from "./CategoryParser";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {CategoryService} from "./CategoryService";
import {useAuthState} from "../../context/AuthContext";
import {
    RaikoAlert,
    raikoAlertTypes, RaikoBaseCardContainer,
    RaikoButtonPrimary, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoDefaultDialogPage, RaikoDivider,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoSimpleInputOutlined
} from "@moeindal/base-raiko-panel-components";
import {DialogSize} from "../defaultDialogPage/DefaultDialogPage";
import {RaikoTree} from "../raikoCategoryTree/RaikoTree";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export default function RaikoCategoryManager() {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const [categoryItems, setCategoryItems] = useState([]);

    const service = new CategoryService(fundID, token, snackbar, loading)

    useEffect(() => {
        getCategoryDataFromServer()
    }, [])

    function getCategoryDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getCategoryList()
            .then(response => {
                setCategoryItems(response)
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات", snackbar, loading)
        }).finally(_ => {
            loading(setLoadingStateDispatch(false))
        })
    }

    useEffect(() => {
        if (typeof categoryItems !== 'undefined' && categoryItems.length > 0) {
            setCategoryGlobalList(new CategoryParser(categoryItems).getCategoryListParsed())
            setCategoryInlineItems(new CategoryParser(categoryItems).getCategoryListInlineParser())
        }
    }, [categoryItems])

    const [name, setName] = useState("");
    const [parent, setParent] = useState(-2);


    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [categoryGlobalList, setCategoryGlobalList] = useState([]);

    const [selectedItemsId, setSelectedItemsId] = useState(-1);


    function handleAddNewCategory() {
        if (checkFields(
            name,
            parent
        )) {
            loading(setLoadingStateDispatch(true))
            service.addNewCategory(
                name,
                parent
            ).then(response => {
                clearFields()
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "دسته بندی جدید با موفقیت افزوده شد."))
                getCategoryDataFromServer()
            }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت اطلاعات", snackbar, loading)
            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })
        }
    }

    function clearFields() {
        setName("")
        setParent(-2)
    }

    function checkFields(
        cName,
        cParentId
    ) {
        let state = false
        let message = ""

        if (cName.length === 0)
            message = "لطفا نام دسته بندی بازی را وارد نمایید"
        else if (cParentId === -2)
            message = "لطفا دسته بندی پدر را مشخص نمایید"
        else
            state = true

        if (message.length > 0)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))

        return state
    }

    const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
    const [categoryDetailDialogOpenState, setCategoryDetailDialogOpenState] = useState(false);


    function handleSelectCategoryItem(itemId, itemName, itemParentId) {
        setSelectedCategoryId(itemId)

        setSelectedName(itemName)
        setSelectedParentId(itemParentId)

        setCategoryDetailDialogOpenState(true)
    }

    function handleCloseDialog() {
        setSelectedCategoryId(-1)
        setCategoryDetailDialogOpenState(false)
    }

    function handleUpdateCategory() {

        if (checkFields(
            selectedName,
            selectedParentId
        )) {
            loading(setLoadingStateDispatch(true))
            service.updateCategoryInfo(
                selectedName,
                selectedParentId,
                selectedCategoryId
            ).then(response => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
                getCategoryDataFromServer()
                setCategoryDetailDialogOpenState(false)
            }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت اطلاعاتss", snackbar, loading)
            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })
        }
    }

    const [selectedName, setSelectedName] = useState("");
    const [selectedParentId, setSelectedParentId] = useState(-1);

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={categoryDetailDialogOpenState}
                pageTitle={"ویرایش دسته بندی"}
                dialogSize={DialogSize.WRAP_CONTENT}>
                <RaikoGridOneColumn className={css`margin: 0 1rem 1rem 1rem`}>
                    <RaikoSimpleInputOutlined labelText={"عنوان"} setValue={setSelectedName} value={selectedName}/>
                    <RaikoCustomSelect
                        items={[
                            raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                            ...categoryInlineItems
                        ]}
                        labelText={"پدر"}
                        value={selectedParentId}
                        setValue={setSelectedParentId}
                    />
                    <div className={css`
                      display: flex;
                      justify-content: end;
                    `}>
                        <RaikoButtonPrimary
                            label={"بروزرسانی"}
                            onClick={handleUpdateCategory}/>
                    </div>
                </RaikoGridOneColumn>
            </RaikoDefaultDialogPage>

            <RaikoGridOneColumn>
                <RaikoGridOneColumn>

                    <RaikoAlert
                        type={raikoAlertTypes.info}
                        title={"مشاهده و ویرایش دسته بندی"}
                        description={[
                            "* برای افزودن دسته بندی جدید بعد از وارد کردن اطلاعات لازم بر روی دکمه ی افزودن کلیک نمایید.",
                            "* برای ویرایش دسته بندی های کافی است دسته بندی مورد نظر را انتخاب کرده و بعد از اصلاح جزئیات بر روی بروزرسانی کلیک نمایید."
                        ]}
                    />


                    <RaikoGridTwoColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"نام"}
                            setValue={setName}
                            value={name}/>

                        <RaikoCustomSelect
                            items={[
                                raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                                ...categoryInlineItems
                            ]}
                            labelText={"پدر"}
                            value={parent}
                            setValue={setParent}
                        />
                    </RaikoGridTwoColumn>
                    <div className={css`
                      display: flex;
                      justify-content: end;
                    `}>
                        <RaikoButtonPrimary label={"افزودن"} onClick={handleAddNewCategory}/>
                    </div>
                </RaikoGridOneColumn>

                {categoryItems && categoryItems.length > 0 ?
                    <RaikoGridOneColumn>

                        <RaikoAlert
                            type={raikoAlertTypes.info}
                            title={"برای ویرایش بر روی دسته بندی مربوطه کلیک نمایید!"}
                            className={css`height: fit-content;
                              width: 100%;`}
                        />
                        <RaikoTree
                            treeItems={categoryGlobalList}
                            selectedItemsId={selectedItemsId}
                            handleItemClicked={handleSelectCategoryItem}/>


                    </RaikoGridOneColumn> :
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"هیچ دسته بندی برای نمایش وجود ندارد!"}
                            description={[
                                "* برای افزودن دسته بندی جدید می توانید از کادر بالا استفاده نمایید."
                            ]}
                        />
                    </RaikoGridOneColumn>
                }


            </RaikoGridOneColumn>
        </>
    )
}